import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { connectFirestoreEmulator, initializeFirestore } from '@angular/fire/firestore';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module'
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFirestore, AngularFirestoreModule, USE_EMULATOR as USE_FIRESTORE_EMULATOR } from '@angular/fire/compat/firestore';
import { AngularFireFunctionsModule, REGION, USE_EMULATOR as USE_FUNCTIONS_EMULATOR } from '@angular/fire/compat/functions'
import { AngularFireAuthModule, USE_EMULATOR as USE_AUTH_EMULATOR } from '@angular/fire/compat/auth';
import { environment } from 'src/environments/environment';
import { MatToolbarModule } from '@angular/material/toolbar'; 
import { MatIconModule } from '@angular/material/icon'; 
import { MatMenuModule } from '@angular/material/menu'; 
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateHttpLoader} from '@ngx-translate/http-loader';
import { MatDialogModule} from '@angular/material/dialog';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeUS from '@angular/common/locales/en'
import { NgxMapboxGLModule } from 'ngx-mapbox-gl';
import { JwtInterceptor } from './jwt.interceptor';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { RedirectComponent } from './redirect/redirect.component';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { getGermanPaginatorIntl } from './german-paginator.intl';
import { determineLocale } from '../../diwimamodelweb/lib';
import { AngularFireStorageModule } from '@angular/fire/compat/storage';
import { getApp, initializeApp,provideFirebaseApp } from '@angular/fire/app';
import { provideFunctions, getFunctions, connectFunctionsEmulator } from '@angular/fire/functions';
import { provideStorage, getStorage, connectStorageEmulator } from '@angular/fire/storage';
import { provideFirestore } from '@angular/fire/firestore';
import { connectAuthEmulator, getAuth, provideAuth } from '@angular/fire/auth';

function getLang() {
  if (navigator.languages != undefined) 
  return navigator.languages[0]; 
  else 
  return navigator.language;
}

registerLocaleData(localeDe)
registerLocaleData(localeUS)

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({ 
    declarations: [
        AppComponent,
        RedirectComponent,
    ],
    bootstrap: [AppComponent], 
    imports: [
        BrowserModule,
        MatToolbarModule,
        MatIconModule,
        MatButtonModule,
        MatMenuModule,
        MatSnackBarModule,
        MatProgressSpinnerModule,
        BrowserAnimationsModule,
        MatDialogModule,
        NgxMapboxGLModule.withConfig({
            accessToken: environment.mapBoxToken
        }),
        AngularFireModule.initializeApp(environment.firebaseConfig),
        AngularFirestoreModule,
        // AngularFirestoreModule.enablePersistence(),//changed to contructor in appmodule
        AngularFireAuthModule,
        AngularFireFunctionsModule,
        // i18n github...
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            // extend: true,
            // defaultLanguage: 'de'
        }),
        // CockpitModule.forRoot({
        //   mapboxToken: environment.mapBoxToken, // Optional, can also be set per map (accessToken input of mgl-map)
        //   // geocoderAccessToken: environment.mapBoxToken // Optional, specify if different from the map access token, can also be set per mgl-geocoder (accessToken input of mgl-geocoder)
        // }),
        AppRoutingModule,
        SharedModule,
        AngularFireStorageModule
      ], 
      providers: [
        provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
        provideFunctions(() => {
            const functions = getFunctions(getApp(), 'europe-west1');
        
          if (environment.useEmulators) {
            connectFunctionsEmulator(functions, '127.0.0.1', 5010);
            console.log("Using emulator for Functions");
          }
        
          return functions;
        }),
        provideFirestore(() => {
          const firestore = initializeFirestore(getApp(), {
            experimentalForceLongPolling: true
          });
        
          if (environment.useEmulators) {
            connectFirestoreEmulator(firestore, '127.0.0.1', 8079);
            console.log("Using emulator for Firestore");
          }
        
          return firestore;
        }),
        provideStorage(() => {
          const storage = getStorage();
          if (environment.useEmulators) {
              connectStorageEmulator(storage, "127.0.0.1", 9198);
              console.log('Using emulator for Storage');
          }
          return storage;
      }),
        provideAuth(() => {
          const auth = getAuth()
          if (environment.useEmulators) {
              connectAuthEmulator(auth, 'http://127.0.0.1:9098', {disableWarnings: true});
              console.log('Using emulator for auth');
          }
          return auth
      }),
        // { provide: NEW_ORIGIN_BEHAVIOR, useValue: true },
        // { provide: ORIGIN, useValue: environment.webAddress }
        { provide: REGION, useValue: 'europe-west1' },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: JwtInterceptor,
            multi: true
        },
        {
          provide: USE_FIRESTORE_EMULATOR,
          useValue: environment.useEmulators
            ? ['127.0.0.1', 8079]
            : undefined
        },
        {
          provide: USE_AUTH_EMULATOR,
          useValue: environment.useEmulators
            ? ['http://127.0.0.1:9098']
            : undefined
        },
        {
          provide: USE_FUNCTIONS_EMULATOR,
          useValue: environment.useEmulators
            ? ['127.0.0.1', 5010]
            : undefined
        },
        { provide: MAT_DATE_LOCALE, useValue: getLang() },
        { provide: MatPaginatorIntl, useValue: (determineLocale(navigator.language) == 'de-DE') ? getGermanPaginatorIntl() : null },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {
  constructor(private afs: AngularFirestore) {
    if (!environment.useEmulators) {
    this.afs.firestore.enablePersistence().then(() => {}).catch((err) => {
      if (err.code === 'failed-precondition') {
        console.warn('!!!!!! Persistence failed: Multiple tabs open');
      } else if (err.code === 'unimplemented') {
        console.warn('!!!! Persistence not supported by browser');
      } else {
        console.error('!!!!Unknown Firestore persistence error:', err);
      }
    });
  }
}
}
